import { AnimatePresence } from 'framer-motion';

import { AuthEventProvider } from '@/context/auth-event-context';

import GetLinkStepOneForm from './get-link-step-one-form';
import GetLinkStepTwo from './get-link-step-two';
import ResetPasswordContainer from './reset-password-container';

export function ResetPassword() {
  return (
    <AuthEventProvider>
      <div className="mx-auto min-h-screen">
        <AnimatePresence>
          <ResetPasswordContainer level={1} key="stepOne">
            <GetLinkStepOneForm />
          </ResetPasswordContainer>
          <ResetPasswordContainer level={2} key="stepTwo">
            <GetLinkStepTwo />
          </ResetPasswordContainer>
        </AnimatePresence>
      </div>
    </AuthEventProvider>
  );
}
